import { cn } from "../../lib/utils";

export function Content(props: {
	children: React.ReactNode;
	className?: string;
}) {
	const className = cn(
		"flex flex-col min-w-full min-h-full w-min h-max",
		props.className,
	);
	return (
		<div className="ScrollArea w-full h-full overflow-auto">
			<div className={className}>{props.children}</div>
		</div>
	);
}
